module.exports = __webpack_public_path__ + "static/apple-icon-152x152-a7cc9214585ca70690471a231d71c8ed.png";